import React from 'react';
import cn from 'classnames';

import EmailSVG from 'Components/Admin/assets/EmailSVG';
import WebsiteSVG from 'Components/Admin/assets/WebsiteSVG';
import LinkedInSVG from 'Components/Admin/assets/LinkedInSVG';

const CompanyCard = ({ entity: company }) => {
  const { email, website, country, city, zip, vatNumber, address1 } = company;

  /*{TODO: remove hardcode when fields will be implemented}*/
  const contacts = [
    { icon: <EmailSVG />, data: email },
    { icon: <WebsiteSVG />, data: website },
    { icon: <LinkedInSVG />, data: 'linkedin.com/spearsllc/' },
  ];

  const rows = [
    {
      isShow: country.name || city.name || address1,
      className: 'company-card__row_location',
      children: (
        <>
          <p>{country.name}</p>
          <p>{city.name}{address1 && ', ' + address1}</p>
        </>
      ),
    },
    {
      isShow: zip || vatNumber,
      className: 'company-card__row_info',
      children: (
        <>
          {
            zip && (
              <div>
                <p className="company-card__label">Zip code</p>
                <p>{zip}</p>
              </div>
            )
          }
          {
            vatNumber && (
              <div>
                <p className="company-card__label">Vat number</p>
                <p>{vatNumber}</p>
              </div>
            )
          }
        </>
      ),
    },
    {
      children: (
        <>
          <p className="company-card__label">Industry</p>
          <div className="company-card__tag">Health and Fitness</div>
        </>
      ),
    },
    {
      className: 'company-card__row_description',
      children: `Enough around remove to barton agreed regret in or it. Advantage mr estimable be commanded provision.`,
    },
  ];

  return (
    <div className="company-card">
      {
        rows.map(({ isShow = true, className, children }, index) => {
          if (!isShow) return null;

          return <div className={cn('company-card__row', className)} key={index}>{children}</div>;
        })
      }
      {
        contacts.map(({ icon, data }, index) => {
          if (!data) return null;

          return (
            <div className="company-card__row company-card__row_contact" key={index}>
              {icon}
              <span>{data}</span>
            </div>
          );
        })
      }
    </div>
  );
};

export default CompanyCard;
